import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import api from "../../../service/api";

import { Container, Row } from "react-bootstrap";

import Header from "../../../components/Header";
import Table from "../../../components/Table";

import Main from "../../../components/Main/index";
import DropdownButton from "../../../components/DropdownButton";
import Modal from "../../../components/ModalSuccessMessage";
import ModalClientsDetail from "../../../components/ModalClientsDetail";
import NavTabs from "../../../components/NavTabs";
import Animation from "../../../components/Animation/animation";

import { THead, Th, ThFilterable, Td } from "./styles";

import routes from "../../../routes/clients.routes";


//Interfaces
import { ClientDataInterface } from "../../clientClientPortal/clientForClient/interfaces";

//Assets
import upArrow from "../../../assets/icons/chevron-up.svg";
import downArrow from "../../../assets/icons/chevron-down.svg";


const Buyers = () => {
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [buyersList, setBuyersList] = useState<Array<any>>([]);
  const [selectedBuyer, setSelectedBuyer] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const login = useSelector((state: {login: any}) => state.login);
  const history = useHistory();

  useEffect(() => {
    if(login.user.groups.am3a2){
      history.push("/admin/dashboard");
    }
  }, []);

  useEffect(() => {
    setIsLoading(true)
    const getBuyersListAtApi = async () => {
      const { data } = await api.get("/adm/owner100pay/list", {
        params: {
          page,
          buyerlist: login.user.owners.id
        }
      });

      setMaxPage(data.pageCount);
      setBuyersList(data.Buyers);
      setIsLoading(false)
    }

    getBuyersListAtApi();
  }, [page])

  const tableContentGenerator = () => {
    return buyersList.map((buyer) => (
      <tr key={buyer.id} style={{ height: 67 }}>
        <Td>{buyer.bu_id}</Td>
        <Td>{buyer.br_businessName}</Td>
        <Td>{buyer.bu_status === "active" ? "ativo" : "inativo"}</Td>
        <Td>{`${buyer.bu_firstName} ${buyer.bu_lastName}`}</Td>
        <Td>{buyer.bu_email}</Td>
        <Td>{buyer.bu_phoneNumber}</Td>
        <Td><DropdownButton selectedUser={buyer} setSelectedUser={setSelectedBuyer} isViewOptionVisible={true} openModal={true} modalId="#details-plans"/></Td>
      </tr>
    ));
  };

  return (
    <Container fluid >
      <Row>
        <Modal text="Adicionado com Sucesso" />
        {true && <ModalClientsDetail title="Informações do comprador" type="buyers" data={selectedBuyer}/>
        //login.user.groups.am3a2r
        } 
        <Main
          className= "column-content"
          isFormVisible={false}
        >
          <Header
            title="Clientes"
            subTitle="Visualize e gerencie toda a sua base de clientes em um só lugar"
            subTitleWidth={229}
          />
          <NavTabs tabs={routes}/>
          <Table
            page={page}
            setPage={setPage}
            maximumPage={maxPage}
            showExportButton={login.user.groups.am3a2e}
          >
            <THead>
              <tr>
                <Th>
                  <ThFilterable>
                    <div>ID</div>
                    <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                      <img src={upArrow} alt="seta para cima" />
                      <br />
                      <img src={downArrow} alt="seta para baixo" />
                    </div>
                  </ThFilterable>
                </Th>
                <Th>
                  <ThFilterable>
                    <div>Vendedor</div>
                    <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                      <img src={upArrow} alt="seta para cima" />
                      <br />
                      <img src={downArrow} alt="seta para baixo" />
                    </div>
                  </ThFilterable>
                </Th>
                <Th>
                  <ThFilterable>
                    <div>Status</div>
                    <div style={{ marginLeft: 3, lineHeight: 0.7 }}>
                      <img src={upArrow} alt="seta para cima" />
                      <br />
                      <img src={downArrow} alt="seta para baixo" />
                    </div>
                  </ThFilterable>
                </Th>
                <Th>Nome completo</Th>
                <Th>Email</Th>
                <Th>Telefone</Th>
                <Th></Th>
              </tr>
            </THead>
            {
              isLoading 
              ? <Animation/>
              : <tbody>
                  { tableContentGenerator() }
              </tbody>
            }
          </Table>
        </Main>
      </Row>
    </Container>
  )
}

export default Buyers;